// extracted by mini-css-extract-plugin
export default {"widget-header":"subscriptionrenewal_widget-header__G5EgT","widget-body":"subscriptionrenewal_widget-body__-lF0Q","dropdown-disabled":"subscriptionrenewal_dropdown-disabled__vljaq"};